/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_S2Inputs */

const en_tut_meja_s2 = /** @type {(inputs: Tut_Meja_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the **Jenis meja**: **Terbuka** follows the room policy, **Privat** creates a 3 × 3 tile quiet zone.`)
};

const id_tut_meja_s2 = /** @type {(inputs: Tut_Meja_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih **Jenis meja**: **Terbuka** mengikuti kebijakan ruang, **Privat** membuat zona tenang 3 × 3 petak.`)
};

/**
* | output |
* | --- |
* | "Choose the **Jenis meja**: **Terbuka** follows the room policy, **Privat** creates a 3 × 3 tile quiet zone." |
*
* @param {Tut_Meja_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_s2 = /** @type {((inputs?: Tut_Meja_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_s2(inputs)
	return en_tut_meja_s2(inputs)
});